import { CertificacionPrecio } from "./CertificacionPrecio";

export class CambioPlanPartner {
	public idPlanSf: string;
	public idEmisor: string;
	public idUsuario: string;
	public idPlanUsuario: string;
	public changeNow: boolean;
	/**
	 *
	 */
	constructor() {}
}
